import parse from "html-react-parser";

type Props = {
    label: string;
    value: boolean | string;
    description: string;
    onCheck: (value: boolean) => void;
};

const ToggleSwitch = (props: Props) => {
    const { label, value, description, onCheck } = props;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        onCheck(e.target.checked);
    };

    // Convert string 'true' to boolean true, everything else to false
    const booleanValue = value === true || value === 'true';

    return (
        <>
            {description && (
                <span>{parse(description)}</span>
            )}
            <div className="mt-2">
                <div className="form-check form-switch">
                    <input
                        checked={booleanValue}
                        className="form-check-input"
                        type="checkbox"
                        role="switch"
                        id="flexSwitchCheckDefault"
                        onChange={handleChange}
                        style={{ cursor: 'pointer' }}
                    />
                    <label className="form-check-label fw-semibold" htmlFor="flexSwitchCheckDefault">{label}</label>
                </div>
            </div>
        </>
    );
};

export default ToggleSwitch;
